import currency from 'currency.js';

export const defaultTipSettings: Pagcomanda.TipSettings = {
  mode: 'none', baseLabel: 'Couvert', baseAmount: 0, defaultPercentage: 10,
  percentages: [10, 15, 20, 30],
};

function amount(value: number) {
  if (!Number.isFinite(value) || value < 0 || value > 1000000) {
    throw new Error('Informe um valor entre zero e 1.000.000.');
  }
  return currency(value).value;
}

export function validateTip(tip: Pagcomanda.TipSelection): Pagcomanda.TipSelection {
  if (!tip || !['percentage', 'fixed'].includes(tip.type)) {
    throw new Error('Tipo de gorjeta inválido.');
  }
  const value = amount(tip.value);
  if (tip.type === 'percentage' && value > 100) {
    throw new Error('O percentual deve estar entre zero e 100.');
  }
  return { type: tip.type, value };
}

export function normalizeTipSettings(input?: Pagcomanda.TipSettings): Pagcomanda.TipSettings {
  const settings = { ...defaultTipSettings, ...input };
  if (!['none', 'optional', 'obligatory'].includes(settings.mode)) {
    throw new Error('Modalidade de gorjeta inválida.');
  }
  if (!Array.isArray(settings.percentages) || settings.percentages.length > 12) {
    throw new Error('Informe até 12 opções de percentual.');
  }
  return {
    mode: settings.mode,
    baseLabel: String(settings.baseLabel || 'Couvert').trim().slice(0, 80),
    baseAmount: amount(settings.baseAmount),
    defaultPercentage: validateTip({ type: 'percentage', value: settings.defaultPercentage }).value,
    percentages: [...new Set(settings.percentages.map((value) => validateTip({ type: 'percentage', value }).value))],
  };
}

export function createBillCharges(settings?: Pagcomanda.TipSettings): Pagcomanda.BillCharges {
  const normalized = normalizeTipSettings(settings);
  return {
    settings: normalized,
    baseAmount: normalized.baseAmount,
    tip: { type: 'percentage', value: normalized.mode === 'none' ? 0 : normalized.defaultPercentage },
  };
}

export function changeBillCharges(
  current: Pagcomanda.BillCharges,
  changes: { tip?: Pagcomanda.TipSelection; baseAmount?: number },
  isStaff: boolean,
): Pagcomanda.BillCharges {
  if (!isStaff && (changes.baseAmount !== undefined
    || (changes.tip !== undefined && current.settings.mode !== 'optional'))) {
    throw new Error('Somente a equipe pode alterar estas cobranças.');
  }
  return {
    ...current,
    tip: changes.tip === undefined ? current.tip : validateTip(changes.tip),
    baseAmount: changes.baseAmount === undefined ? current.baseAmount : amount(changes.baseAmount),
  };
}

export function calculateBillCharges(subtotal: number, charges?: Pagcomanda.BillCharges) {
  const base = currency(charges?.baseAmount ?? 0);
  const tip = charges?.tip.type === 'fixed'
    ? currency(charges.tip.value)
    : currency(subtotal).multiply((charges?.tip.value ?? 0) / 100);
  return { base: base.value, tip: tip.value, total: base.add(tip).value };
}
